export default "__VITE_ASSET__ClIJmsNh__"